import { render, staticRenderFns } from "./videoStudy.vue?vue&type=template&id=7129906e&scoped=true"
import script from "./videoStudy.vue?vue&type=script&lang=js"
export * from "./videoStudy.vue?vue&type=script&lang=js"
import style0 from "./videoStudy.vue?vue&type=style&index=0&id=7129906e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7129906e",
  null
  
)

export default component.exports